import type { StreetOrientation } from "building-types/building/streetOrientationTypesEnum";
import type { PlanarGraphPerimeterInfo } from "building-types/planarGraphs/planarGraphPerimeterInfo";

export function getStreetOrientationForHalfEdge(
  halfEdgeIndex: number,
  perimeterInfo: PlanarGraphPerimeterInfo | undefined,
): StreetOrientation | undefined {
  return perimeterInfo?.coveredPerimeterStreetOrientations[halfEdgeIndex];
}
